export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/faqBanner.b2568d82.svg","height":262,"width":1347,"blurWidth":0,"blurHeight":0};